import { useIntl } from "react-intl";

import Dialog from "components/organisms/Dialog/Dialog";
import useFeatureFlag from "hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "constants/featureFlags";
import BillingInfoAddressV1 from "./BillingInfoAddressV1";
import BillingInfoAddressV2 from "./BillingInfoAddressV2";
import BillingInfoDialogLegacy from "./BillingInfoDialogLegacy";

interface IBillingInfoProps {
  isOpen: boolean;
  close: () => void;
  isAddressV2Enabled?: boolean;
}

function BillingInfoDialog(props: IBillingInfoProps) {
  const { isOpen, close, isAddressV2Enabled = false } = props;

  const intl = useIntl();
  const isInvoiceAddressV2FeatureEnabled = useFeatureFlag(FEATURE_FLAGS.WEB_9731_INVOICE_ADDRESS_V2);

  const handleSubmitBillingInfo = () => {
    close();
  };

  if (!isInvoiceAddressV2FeatureEnabled) {
    return <BillingInfoDialogLegacy isOpen={isOpen} close={close} />;
  }

  return (
    <Dialog
      size="sm"
      title={intl.formatMessage({
        id: "billing.billingInformation",
        defaultMessage: "Billing information",
      })}
      show={isOpen}
      onHide={close}
    >
      {isAddressV2Enabled ? (
        <BillingInfoAddressV2 onSubmit={handleSubmitBillingInfo} onClose={close} />
      ) : (
        <BillingInfoAddressV1 onSubmit={handleSubmitBillingInfo} onClose={close} />
      )}
    </Dialog>
  );
}

export default BillingInfoDialog;
